import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CollectionAddMemberFacade } from '@mode/collections/domain';
import { SpaceDomain } from '@mode/shared/contract-common';
import { findIndex } from 'lodash';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mode-accessor-search',
  templateUrl: './accessor-search.component.html',
  styleUrls: ['./accessor-search.component.scss'],
})
export class AccessorSearchComponent implements OnInit, OnDestroy {
  searchResults$: Observable<Array<SpaceDomain.PermissionsSearchResult>>;
  searchResults: Array<SpaceDomain.PermissionsSearchResult> = [];
  activeSearchResult: SpaceDomain.PermissionsSearchResult | undefined;
  searchResultsSub: Subscription;

  @Input() disabled = false;
  @Input() spaceId!: string;
  @Input() orgName!: string;

  constructor(private addMemberFacade: CollectionAddMemberFacade) {
    this.searchResults$ = combineLatest([
      this.addMemberFacade.searchResults$,
      this.addMemberFacade.selectedResults$,
    ]).pipe(
      map(([queryResults, selected]) => {
        const selectedResultTokens = selected.map((selected) => selected.token);
        const filteredResults = queryResults.filter((result) => !selectedResultTokens.includes(result.token));
        // return only the first 10 filtered results for better UX
        return filteredResults.slice(0, 10);
      })
    );

    this.searchResultsSub = this.searchResults$.subscribe((results) => {
      this.searchResults = results;
      this.activeSearchResult = results[0];
    });
  }

  ngOnInit(): void {
    this.updateQuerySearchParams('');
  }

  updateQuerySearchParams(query: string) {
    this.addMemberFacade.updateQuerySearchParams({ orgName: this.orgName, spaceId: this.spaceId, query: query });
  }

  valueChanged(query: string) {
    this.updateQuerySearchParams(query);
  }

  selectNextItem() {
    const currentIndex = findIndex(this.searchResults, this.activeSearchResult);
    this.activeSearchResult = this.searchResults[currentIndex + 1] || this.searchResults[0];
  }

  selectPreviousItem() {
    const currentIndex = findIndex(this.searchResults, this.activeSearchResult);
    this.activeSearchResult = this.searchResults[currentIndex - 1] || this.searchResults[this.searchResults.length - 1];
  }

  selectItem(item: any) {
    this.activeSearchResult = this.searchResults.find((result) => result.token === item.token);
    this.addActiveItemToSelectedResults();
  }

  addActiveItemToSelectedResults() {
    const activeSearchResult = this.activeSearchResult as SpaceDomain.PermissionsSearchResult;
    this.addMemberFacade.addSelectedResult(activeSearchResult);
  }

  ngOnDestroy() {
    this.searchResultsSub.unsubscribe();
  }
}
